<script lang="ts" setup>
  import { ref } from "vue";
  import { useAppStore } from "@/stores/app";
  import { useRouter } from "vue-router";
  import NewUser from "@/components/modals/subscription_flow/welcome_step/NewUser.vue";
  import OldUser from "@/components/modals/subscription_flow/welcome_step/OldUser.vue";

  const appStore = useAppStore();
  const router = useRouter();

  const isNewUser = ref<boolean>(router.options.history.state.back === '/sign-up');

</script>

<template>
  <NewUser v-if="isNewUser" />
  <OldUser v-else />
</template>

<style lang="scss" scoped>
</style>
